import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { catchError, Observable, of, tap } from "rxjs";


@Injectable({
  providedIn: "root",
})
export class AssetsDataService {

  private texts: any

  public texts$ = this.getSettings()


  constructor(private http: HttpClient) { }


  getSettings(): Observable<any> {   

    return this.texts
      ? of(this.texts)
      : this.http.get("assets/data/texts.json")
          .pipe(
            catchError(() => of(null)),
            tap((o: any) => this.texts = o )
          )
  }

}
